import { render, staticRenderFns } from "./StepWasteBags.vue?vue&type=template&id=604e4c2d&lang=html&"
import script from "./StepWasteBags.vue?vue&type=script&lang=js&"
export * from "./StepWasteBags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports